@if (isLoader) {
  <div class="loader">
    <mat-spinner style="width: 50px; height: 50px"></mat-spinner>
  </div>
} @else {
  <div
    class="modal-props-container p-4 d-flex flex-column justify-content-center align-items-center"
    [formGroup]="createForm"
  >
    <mat-form-field class="w-100">
      <mat-label>{{ 'name_template' | translate }}</mat-label>
      <input matInput [formControl]="createForm.controls.name" />
      @if (createForm.controls['name'].status === 'INVALID') {
        <mat-hint>{{ 'field_cannot_be_empty' | translate }}.</mat-hint>
      }
    </mat-form-field>
    <div class="w-100">
      <div>
        <h3>{{ 'shipping_parameters' | translate }}</h3>
        <div class="ps-5">
          <mat-radio-group [formControl]="createForm.controls.box">
            <mat-radio-button value="1">{{ 'parcels_and_cargoes' | translate }}</mat-radio-button>
            <mat-radio-button value="2" [disabled]="true">{{ 'documents' | translate }}</mat-radio-button>
            <mat-radio-button value="3" [disabled]="true">{{ 'pallets' | translate }}</mat-radio-button>
            <mat-radio-button value="4" [disabled]="true">{{ 'tires_and_wheels' | translate }}</mat-radio-button>
          </mat-radio-group>
          <div class="d-flex flex-row">
            <div>
              <form class="example-form">
                <mat-form-field class="example-full-width">
                  <mat-label>{{ 'product_description' | translate }}</mat-label>
                  <input
                    type="text"
                    placeholder="{{ 'product_description' | translate }}"
                    matInput
                    [formControl]="createForm.controls.description_product"
                    [matAutocomplete]="auto"
                  />
                  <mat-autocomplete #auto="matAutocomplete">
                    @for (cargo of filteredCargos | async; track cargo) {
                      <mat-option [value]="cargo.Description">{{ cargo.Description }}</mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </form>
            </div>
            <div class="d-flex flex-column ps-4">
              <label>{{ 'the_declared_cost' | translate }}</label>
              <mat-radio-group aria-label="Select an option" [formControl]="createForm.controls.price">
                <mat-radio-button value="1" checked>{{ 'from_the_transaction' | translate }}</mat-radio-button>
                <mat-radio-button value="2">{{ 'minimum' | translate }}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div>
            <mat-checkbox class="example-margin" color="'#483CE4'" [formControl]="createForm.controls.params"
              >Загальні параметри</mat-checkbox
            >
            <div>
              @if (createForm.controls.params?.value) {
                <div class="d-flex flex-row">
                  <mat-form-field class="w-100">
                    <mat-label>{{ 'total_weight' | translate }}</mat-label>
                    <input maxlength="4" mask="0*" [formControl]="createForm.controls.global_weight" matInput />
                  </mat-form-field>
                  <p class="pt-24">кг</p>
                  <mat-form-field class="w-100">
                    <mat-label>{{ 'total_volume' | translate }}</mat-label>
                    <input maxlength="4" mask="0*" [formControl]="createForm.controls.volume_length" matInput />
                  </mat-form-field>
                  <p class="pt-24">m<sup>3</sup></p>
                  <mat-form-field class="w-100">
                    <mat-label>{{ 'number_of_places' | translate }}</mat-label>
                    <input maxlength="4" mask="0*" [formControl]="createForm.controls.number_seats" matInput />
                  </mat-form-field>
                  <p class="pt-24">шт</p>
                  <mat-form-field class="w-100 text-info-number">
                    <mat-label
                      >{{ 'volumetric_weight' | translate }}
                      <app-icon matTooltip="{{ 'dimensional_weight' | translate }}">help_outline</app-icon></mat-label
                    >
                    <input matInput [disabled]="true" [value]="calcWeight()" />
                  </mat-form-field>
                </div>
              }
              @if (!createForm.controls.params?.value) {
                <div>
                  @for (globalParams of getGlobalParams().controls; track globalParams; let iParams = $index) {
                    <div class="d-flex flex-column">
                      <ng-container>
                        <ng-container [formGroupName]="iParams">
                          <div class="d-flex flex-row">
                            <mat-form-field class="w-100">
                              <mat-label>{{ 'weight' | translate }}</mat-label>
                              <input maxlength="4" mask="0*" formControlName="weight" matInput />
                            </mat-form-field>
                            <p class="pt-24">kg</p>
                            <mat-form-field class="w-100">
                              <mat-label>{{ 'length' | translate }}</mat-label>
                              <input maxlength="4" mask="0*" formControlName="length" matInput />
                            </mat-form-field>
                            <mat-form-field class="w-100">
                              <mat-label>{{ 'width' | translate }}</mat-label>
                              <input maxlength="4" mask="0*" formControlName="width" matInput />
                            </mat-form-field>
                            <mat-form-field class="w-100">
                              <mat-label>Висота</mat-label>
                              <input maxlength="4" mask="0*" formControlName="height" matInput />
                            </mat-form-field>
                            <p class="pt-24">см</p>
                            <mat-form-field class="w-100 text-info-number">
                              <mat-label
                                >{{ 'volumetric_weight' | translate }}
                                <app-icon matTooltip="{{ 'dimensional_weight' | translate }}"
                                  >help_outline</app-icon
                                ></mat-label
                              >
                              <input matInput [disabled]="true" [value]="calcWeight(globalParams)" />
                            </mat-form-field>
                            <app-button
                              btnType="icon"
                              (onChangeClick)="copyPlace(globalParams)"
                              matTooltip="{{ 'copy_place' | translate }}"
                              ><app-icon>content_copy</app-icon></app-button
                            >
                            @if (getGlobalParams().controls.length > 1) {
                              <app-button
                                (onChangeClick)="removePlace(iParams)"
                                btnType="icon"
                                matTooltip="{{ 'delete_a_place' | translate }}"
                                ><app-icon>close</app-icon></app-button
                              >
                            }
                          </div>
                          <div>
                            <mat-radio-group>
                              <mat-checkbox
                                [disabled]="!manualDisabled(globalParams)"
                                class="example-margin"
                                color="'#483CE4'"
                                matTooltip="{{ 'shipment_parameters' | translate }}"
                                >{{ 'manual_processing' | translate }}</mat-checkbox
                              >
                              <app-icon class="size-icon-info" matTooltip="{{ 'check_shipment' | translate }}"
                                >help_outline</app-icon
                              >
                            </mat-radio-group>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  }
                </div>
              }
              <div class="d-flex flex-column py-3">
                <app-button (onChangeClick)="createPlace()">{{ 'add a place' | translate }}</app-button>
              </div>
            </div>
          </div>
          <div class="d-flex flex-column">
            <label>{{ 'payer_for_delivery' | translate }}</label>
            <mat-radio-group aria-label="Select an option" [formControl]="createForm.controls.payer_delivery">
              <mat-radio-button value="1">{{ 'recipient' | translate }}</mat-radio-button>
              <mat-radio-button value="2">{{ 'sender' | translate }}</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="d-flex flex-column">
            <label>{{ 'form_of_payment_for_delivery' | translate }}</label>
            <mat-radio-group
              class="d-flex justify-content-start"
              aria-label="Select an option"
              [formControl]="createForm.controls.form_payment"
            >
              <mat-radio-button value="1">{{ 'cash' | translate }}</mat-radio-button>
              <mat-radio-button value="2" [disabled]="true">{{ 'cashless' | translate }}</mat-radio-button>
              <app-icon class="size-icon-info" matTooltip="{{ 'check_shipment' | translate }}">help_outline</app-icon>
            </mat-radio-group>
          </div>
          <div class="d-flex flex-column">
            <mat-form-field>
              <mat-label>{{ 'Internal_number _of_the_shipment' | translate }}({{ 'optional' | translate }})</mat-label>
              <input matInput [formControl]="createForm.controls.internal_shipment_number" />
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'accompanying_documents' | translate }}({{ 'optional' | translate }})</mat-label>
              <input matInput [formControl]="createForm.controls.document" />
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'package_number' | translate }}({{ 'optional' | translate }})</mat-label>
              <input matInput [formControl]="createForm.controls.package_number" />
            </mat-form-field>
            <mat-form-field>
              <mat-label
                >{{ 'additional_information_about_the_shipment' | translate }}({{ 'optional' | translate }})</mat-label
              >
              <input matInput [formControl]="createForm.controls.additional_information" />
            </mat-form-field>
          </div>
        </div>
        <h3>{{ 'sender' | translate }}</h3>
        <div class="ps-5">
          <div class="d-flex flex-column">
            <mat-form-field>
              <mat-label>{{ 'contact' | translate }}</mat-label>
              <mat-select [disabled]="contacts.length === 1" [formControl]="createForm.controls.contact">
                @for (contact of contacts; track contact) {
                  <mat-option [value]="contact">{{ contact.Description }} ({{ contact.Phones }})</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'address' | translate }}</mat-label>
              <mat-select [disabled]="addresses.length === 1" [formControl]="createForm.controls.address">
                @for (address of addresses; track address) {
                  <mat-option [value]="address">{{ address.AddressDescription }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <h3>{{ 'additional_services' | translate }}</h3>
        <div class="ps-5">
          <div class="d-flex flex-column gap-2">
            <app-toggle [formControl]="createForm.controls.remittance_payer_delivery">{{
              'money_transfer' | translate
            }}</app-toggle>
            @if (createForm.controls.remittance_payer_delivery?.value) {
              <div class="d-flex flex-column">
                <label>{{ 'payer_for_delivery' | translate }}</label>
                <mat-radio-group aria-label="Select an option" [formControl]="createForm.controls.price">
                  <mat-radio-button value="1">{{ 'sender' | translate }}</mat-radio-button>
                  <mat-radio-button value="2">{{ 'recipient' | translate }}</mat-radio-button>
                </mat-radio-group>
              </div>
            }
            <app-toggle [disabled]="true">{{ 'payment_control' | translate }}</app-toggle>
            <app-toggle [disabled]="true">{{ 'return_delivery_of_documents' | translate }}</app-toggle>
            <app-toggle [disabled]="true">{{ 'return_delivery_of_signed_documents' | translate }}</app-toggle>
            <app-toggle [disabled]="true">{{ 'return_delivery_of_document_subtypes' | translate }}</app-toggle>
            <app-toggle [disabled]="true">{{ 'control_of_piecewise_transmission' | translate }}</app-toggle>
            <app-toggle [disabled]="true">{{ 'packaging' | translate }}</app-toggle>
            <app-toggle [disabled]="true">{{ 'climbing_to_the_floor' | translate }}</app-toggle>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row justify-content-end gap-2">
        <app-button btnType="stroked" (onChangeClick)="cancel()">{{ 'cancel' | translate }}</app-button>
        <app-button (onChangeClick)="save()">{{ 'save' | translate }}</app-button>
      </div>
    </div>
  </div>
}
